/** @typedef {string} AsyncDownloadType */
export const ASYNC_DOWNLOAD_TYPE_CUSTOMER_MESSAGE_DELIVERIES = 'CUSTOMER_MESSAGE_DELIVERIES';
export const ASYNC_DOWNLOAD_TYPE_CUSTOMER_MESSAGE = 'CUSTOMER_MESSAGE';
/** @enum {AsyncDownloadType} */
export const ASYNC_DOWNLOAD_TYPE = {
	CUSTOMER_MESSAGE_DELIVERIES: ASYNC_DOWNLOAD_TYPE_CUSTOMER_MESSAGE_DELIVERIES,
	CUSTOMER_MESSAGE: ASYNC_DOWNLOAD_TYPE_CUSTOMER_MESSAGE,
}
/** @type {AsyncDownloadType[]} */
export const ASYNC_DOWNLOAD_TYPES = [
	ASYNC_DOWNLOAD_TYPE_CUSTOMER_MESSAGE_DELIVERIES,
	ASYNC_DOWNLOAD_TYPE_CUSTOMER_MESSAGE,
];


/** @typedef {string} AsyncDownlaodFormat */
export const ASYNC_DOWNLOAD_FORMAT_CSV = 'CSV';
export const ASYNC_DOWNLOAD_FORMAT_EXCEL = 'EXCEL';
/** @enum {AsyncDownlaodFormat} */
export const ASYNC_DOWNLOAD_FORMAT = {
	CSV: ASYNC_DOWNLOAD_FORMAT_CSV,
	EXCEL: ASYNC_DOWNLOAD_FORMAT_EXCEL,
}
/** @type {AsyncDownlaodFormat[]} */
export const ASYNC_DOWNLOAD_FORMATS = [
	ASYNC_DOWNLOAD_FORMAT_CSV,
	ASYNC_DOWNLOAD_FORMAT_EXCEL,
];
export const ASYNC_DOWNLOAD_FORMAT_EXT = {
	[ASYNC_DOWNLOAD_FORMAT.CSV]: 'csv',
	[ASYNC_DOWNLOAD_FORMAT.EXCEL]: 'xlsx',
};


/** @enum {AsyncDownloadCheckListItemStatus} */
export const ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS_PENDING = 'PENDING';
export const ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS_IN_PROGRESS = 'IN_PROGRESS';
export const ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS_SUCCEEDED = 'SUCCEEDED';
export const ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS_FAILED = 'FAILED';
/** @typedef {string} AsyncDownloadCheckListItemStatus */
export const ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS = {
	PENDING: ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS_PENDING,
	IN_PROGRESS: ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS_IN_PROGRESS,
	SUCCEEDED: ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS_SUCCEEDED,
	FAILED: ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS_FAILED,
}
/** @type {AsyncDownloadCheckListItemStatus[]} */
export const ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUSES = [
	ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS_PENDING,
	ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS_IN_PROGRESS,
	ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS_SUCCEEDED,
	ASYNC_DOWNLOAD_CHECK_LIST_ITEM_STATUS_FAILED,
];

